import { Flex, Popconfirm, Tag, Tooltip } from 'antd';
import { AuthorizedIcon, Icon } from '../../../../../components';
import TrashSolidBlack from '../../../../../assets/icons/trash-solid-b-black.svg';
import PenToSquareSolidBlack from '../../../../../assets/icons/pen-to-square-solid-w-black.svg';
import EyeRegularWBlack from '../../../../../assets/icons/eye-regular-w-black.svg';
import Variant99Black from '../../../../../assets/icons/variant99-black.svg';
import FolderOpenRegular from '../../../../../assets/icons/folder-open-regular.svg';
import styles from './index.module.scss';
import { status_colors } from '../../../../../assets/conts';
import { IEnum } from '../../../../../services/type';
import { getValueFromEnum } from '../../../../../utils/functions';
import { ColumnType } from 'antd/es/table';
import { actionTypes } from '../../../../../assets/enums';
import {
  IFile,
  IOrganization,
  IGroupHealthInsuranceIndividualsDataSource,
} from '../../../../../types';

export const getColumns = (
  handleClickEye: (id: number) => void,
  handleOpenEditModal: (id: number) => void,
  handleClickDelete: (id: number) => Promise<void>,
  handleClickCancel: (id: number) => Promise<void>,
  handleChangeCancelledItem: (
    item: IGroupHealthInsuranceIndividualsDataSource,
  ) => void,
  handleSetAdditionalFile: (id: number, file: IFile[]) => void,
  organizations: IOrganization[],
  statusChoices: IEnum[],
  policyTypes: IEnum[],
): Array<
  ColumnType<IGroupHealthInsuranceIndividualsDataSource> & {
    searchable?: boolean;
  }
> => [
  {
    title: 'Şirket',
    dataIndex: 'organization',
    key: 'organization',
    width: 125,
    searchable: true,
    filters: organizations.map((item) => ({
      text: item.name || '',
      value: item.id,
    })),
    sorter: (a, b) => a.organization - b.organization,
    render: (_, record) => (
      <Tooltip
        title={
          organizations.find((item) => item.id === record.organization)?.name
        }
      >
        <span>{`${organizations.find((item) => item.id === record.organization)?.name.slice(0, 15)}...`}</span>
      </Tooltip>
    ),
  },
  {
    title: 'İsim',
    dataIndex: 'first_name',
    key: 'first_name',
    searchable: true,
    width: 200,
    sorter: (a, b) => a.first_name?.localeCompare(b.first_name),
  },
  {
    title: 'Soyisim',
    dataIndex: 'last_name',
    key: 'last_name',
    searchable: true,
    width: 200,
    sorter: (a, b) => a.last_name?.localeCompare(b.last_name),
  },
  {
    title: 'TCKN',
    dataIndex: 'turkish_id',
    key: 'turkish_id',
    searchable: true,
    width: 200,
    sorter: (a, b) => a.turkish_id?.localeCompare(b.turkish_id),
  },
  {
    title: 'Cinsiyet',
    dataIndex: 'gender',
    key: 'gender',
    width: 160,
    filters: [
      { value: 'male', text: 'Erkek' },
      { value: 'female', text: 'Kadın' },
    ],
    filterMode: 'tree',
    filterSearch: true,
    sorter: (a, b) => a.gender?.localeCompare(b.gender),
    render: (
      _: unknown,
      record: IGroupHealthInsuranceIndividualsDataSource,
    ) => (
      <div>
        {record.gender === 'male'
          ? 'Erkek'
          : record.gender === 'female'
            ? 'Kadın'
            : ''}
      </div>
    ),
  },
  {
    title: 'Doğum Tarihi',
    dataIndex: 'birthday',
    key: 'birthday',
    width: 160,
    sorter: (a, b) => a.birthday?.localeCompare(b.birthday),
  },
  {
    title: 'GSM No',
    dataIndex: 'gsm',
    key: 'gsm',
    searchable: true,
    width: 160,
    sorter: (a, b) => a.gsm?.localeCompare(b.gsm),
  },
  {
    title: 'Uyruk',
    dataIndex: 'nationality',
    key: 'nationality',
    filters: [
      { value: 'tc', text: 'TC' },
      { value: 'other', text: 'Diğer' },
    ],
    filterMode: 'tree',
    filterSearch: true,
    width: 160,
    sorter: (a, b) => a.nationality?.localeCompare(b.nationality),
    render: (
      _: unknown,
      record: IGroupHealthInsuranceIndividualsDataSource,
    ) => (
      <div>
        {record.nationality === 'tc'
          ? 'TC'
          : record.nationality === 'other'
            ? 'Diğer'
            : ''}
      </div>
    ),
  },
  /* {
    title: 'Poliçe No',
    dataIndex: 'policy_number',
    key: 'policy_number',
    searchable: true,
    width: 150,
    sorter: (a, b) => a.policy_number - b.policy_number,
  }, */
  {
    title: 'Branş',
    dataIndex: 'branch',
    key: 'branch',
    width: 160,
    filters: policyTypes.map((item) => ({
      text: item.value,
      value: item.key,
    })),
    filterMode: 'tree',
    filterSearch: true,
    sorter: (a, b) => a.branch?.localeCompare(b.branch),
    render: (
      _: unknown,
      record: IGroupHealthInsuranceIndividualsDataSource,
    ) => (
      <Tag className={styles[`${record.branch}Tag`]}>
        {getValueFromEnum(policyTypes, record.branch)}
      </Tag>
    ),
  },
  {
    title: 'Durum',
    dataIndex: 'recent_status',
    key: 'recent_status',
    width: 150,
    filters: statusChoices.map((item) => ({
      text: getValueFromEnum(statusChoices, item.key) || '',
      value: item.key,
    })),
    filterMode: 'tree',
    filterSearch: true,
    render: (
      _: unknown,
      record: IGroupHealthInsuranceIndividualsDataSource,
    ) => (
      <Tag color={status_colors[record.recent_status]}>
        {getValueFromEnum(statusChoices, record.recent_status)}
      </Tag>
    ),
  },
  {
    title: 'İşlem',
    dataIndex: 'action',
    key: 'action',
    width: 160,
    render: (
      _: unknown,
      record: IGroupHealthInsuranceIndividualsDataSource,
    ) => (
      <Flex justify="flex-end" gap={14}>
        <Icon
          source={EyeRegularWBlack}
          popoverText={actionTypes.VIEW}
          onClick={() => record?.id && handleClickEye(record.id)}
        />
        {record.recent_status !== 'cancelled' && (
          <AuthorizedIcon
            action="add"
            model="grouphealthinsuranceindividuals"
            source={Variant99Black}
            popoverText={actionTypes.CANCEL}
            onClick={() => handleChangeCancelledItem(record)}
          />
        )}
        <Popconfirm
          title={
            <div className={styles.popconfirmTitle}>
              Silme işlemini onaylıyor musunuz?
            </div>
          }
          overlayInnerStyle={{
            width: 150,
            borderColor: '#D6222A',
            borderWidth: 1,
            borderStyle: 'solid',
          }}
          okText="Onayla"
          cancelText="İptal"
          icon={null}
          color="#FAFAFA"
          okButtonProps={{ danger: true, style: { width: '45%' } }}
          cancelButtonProps={{ danger: true, style: { width: '45%' } }}
          onConfirm={() => record.id && handleClickDelete(record.id)}
        >
          <AuthorizedIcon
            action="delete"
            model="grouphealthinsuranceindividuals"
            popoverText={actionTypes.DELETE}
            source={TrashSolidBlack}
          />
        </Popconfirm>
        <AuthorizedIcon
          action="change"
          model="grouphealthinsuranceindividuals"
          popoverText={actionTypes.CHANGE}
          source={PenToSquareSolidBlack}
          onClick={() => record?.id && handleOpenEditModal(record.id)}
        />
        <AuthorizedIcon
          action="view"
          model="grouphealthinsuranceindividualsadditionalfile"
          popoverText={actionTypes.ADDITIONAL_FILE}
          source={FolderOpenRegular}
          onClick={() =>
            handleSetAdditionalFile(record.id, record.additional_files)
          }
        />
      </Flex>
    ),
  },
];
